module.exports = __webpack_public_path__ + "img/third-logo.cca6369c.png";